import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  column-count: ", ";\n  min-height: 250px;\n"])), function (_ref) {
  var columns = _ref.columns;
  return columns;
});